import pannellum from "pannellum";
import { Fancybox } from "@fancyapps/ui";

/**
 *  App class
 *
 *  The App class functions a the main back-bone of the javascript used in this
 *  project.
 *
 */

class Gallery {
    /**
     *  Constructor
     */
    constructor() {
        document.addEventListener("DOMContentLoaded", function () { });
    }

    onInit(panoramaItems) {
        Fancybox.bind(".js-fancybox-content, [data-fancybox]", {
            Toolbar: {
                display: [
                    "thumbs",
                    "close",
                ],
            },
        });

        const galleryTriggers = document.querySelectorAll(
            ".js-gallery-trigger"
        );
        const panoramaTriggers = document.querySelectorAll(
            ".js-panorama-trigger"
        );

        for (let i = 0; i < galleryTriggers.length; i++) {
            const trigger = galleryTriggers[i];
            const id = trigger.dataset.galleryGroup;

            if (!id) {
                return;
            }

            const galleryFirstItem = document.querySelector(
                'a[data-fancybox="' + id + '"]'
            );

            trigger.addEventListener("click", function () {
                galleryFirstItem.click();
            });
        }

        const self = this;

        for (let i = 0; i < panoramaTriggers.length; i++) {
            const trigger = panoramaTriggers[i];
            trigger.addEventListener("click", function () {
                self.handleObjectPanorama(panoramaItems);
            });
        }
    }

    handleObjectPanorama(items) {
        let selectElem = '<select class="js-panorama-select sign-s">';

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const title = item.title ? item.title : "Foto " + (i + 1);
            selectElem += '<option value="' + i + '">' + title + "</option>";
        }

        selectElem += "</select>";

        Fancybox.show(
            [{
                src: `<div class="fancybox__inner">${selectElem}<div id="pannellum-panorama"></div></div>`,
                type: "html",
            }],
            {
                dragToClose: false,
                on: {
                    done: (fancybox) => {
                        const select = document.querySelector(
                            ".js-panorama-select"
                        );

                        let url = items[0].url;

                        if (select) {
                            url = items[select.value].url;
                            select.addEventListener("change", updateViewer);
                        }

                        window.pannellum.viewer("pannellum-panorama", {
                            type: "equirectangular",
                            panorama: url,
                            autoLoad: true,
                        });

                        function updateViewer() {
                            window.pannellum.viewer("pannellum-panorama", {
                                type: "equirectangular",
                                panorama: items[select.value].url,
                                autoLoad: true,
                            });
                        }
                    }
                },
            },
        );
    }

    handleObjectGallery(obj) {
        Fancybox.bind('[data-fancybox="' + obj.group + '"]', {
            mainClass: "fancybox-custom-layout",
            Toolbar: {
                display: [
                    {
                        id: "counter",
                        position: "center",
                    },
                    "thumbs",
                    "close",
                ],
            },

            on: {
                initLayout: (fancybox) => {
                  // Create elements
                  // ===
            
                  // Create left column
                  const $leftCol = document.createElement("div");
                  $leftCol.classList.add("fancybox__leftCol");
            
                  while (fancybox.$container.firstChild) {
                    $leftCol.appendChild(fancybox.$container.firstChild);
                  }
            
                  // Create right column
                  const $rightCol = document.createElement("div");
                  $rightCol.classList.add("fancybox__rightCol");
            
                  $rightCol.innerHTML = `<div class="caption__title">${obj.captionTitle}</div><div class="caption__subtitle sign">${obj.captionSubtitle}</div><p>${obj.captionContent}</p>`;
            
                  // Create info-box
                  const $info = document.createElement("div");
                  $rightCol.appendChild($info);
                  fancybox.$info = $info;
            
                  // Add elements to DOM
                  fancybox.$container.appendChild(fancybox.$backdrop);
            
                  fancybox.$container.appendChild($leftCol);
                  fancybox.$container.appendChild($rightCol);
            
                  fancybox.$leftCol = $leftCol;
                  fancybox.$rightCol = $rightCol;
                },
                "Carousel.ready Carousel.change": (fancybox, carousel, slideIndex) => {
                  // Update info-box
                  // ===
            
                  // Get index of the current gallery item
                  slideIndex =
                    slideIndex === undefined ? carousel.options.initialPage : slideIndex;
            
                  // Get link related to current item
                  const $trigger = fancybox.items[slideIndex].$trigger;
            
                  // Get data from `data-info` attribute
                  const data = $trigger.dataset.info || "";
            
                  // Update info
                  fancybox.$info.innerHTML = `<p>${data}</p>`;
                },
              },
        });
    }
}

window.Gallery = new Gallery();
